import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import CompatStoryCard from "cards/containers/CompatStoryCard";
import StreamSpinner from "stream/components/StreamSpinner";
import { loadRevision, loadLatest } from "actions/storiesStream";
import { getLocalItem } from "utils/localdb";

class Preview extends React.Component {
  componentDidMount() {
    const adminToken = getLocalItem("adminToken");

    if (this.props.revision) {
      return this.props.loadRevision(
        this.props.permalinkId,
        this.props.revision,
        adminToken
      );
    } else {
      return this.props.loadLatest(this.props.permalinkId, adminToken);
    }
  }

  render() {
    if (!this.props.story) return <StreamSpinner />;
    return <CompatStoryCard story={this.props.story} index={0} />;
  }
}

const mapStateToProps = state => ({
  story: state.storiesStream.results[0],
});

const mapDispatchToProps = {
  loadLatest,
  loadRevision,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Preview);

Preview.propTypes = {
  permalinkId: PropTypes.string.isRequired,
  revision: PropTypes.string,
  loadLatest: PropTypes.func.isRequired,
  loadRevision: PropTypes.func.isRequired,
  story: PropTypes.object,
};
